import { ComponentPropDefinitionUtil, ComponentPropDefinitions } from "../../base/ComponentProps";
import { ExcludableTextboxOrientation } from "./ExcludableTextboxOrientation";
import { PanelPropDefinitions, PanelProps } from "../panel/PanelProps";
import { PropType } from "../../base/PropType";

export interface ExcludableTextboxProps extends PanelProps {
    orientation: ExcludableTextboxOrientation;
    rangeDefault: boolean;
    rangeOffered: boolean;
}

export class ExcludableTextboxPropDefinitions {
    private static excludableTextboxPropDefs: ComponentPropDefinitions;

    public static getDefinitions(): ComponentPropDefinitions {
        if (this.excludableTextboxPropDefs == null) {
            this.excludableTextboxPropDefs = {
                ...PanelPropDefinitions.cloneDefs(),
                ...this.buildSimpleProps()       
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(this.excludableTextboxPropDefs);
            this.excludableTextboxPropDefs.searchOnly.defaultValue = true;
        }
        return this.excludableTextboxPropDefs;
    }

    private static buildSimpleProps(): ComponentPropDefinitions {
        return {
            orientation: {
                type: PropType.string,
                dropdownProps: { items: Object.values(ExcludableTextboxOrientation), allowDropdownBlank: false },
                defaultValue: ExcludableTextboxOrientation.STACKED,
                visibleInMcLeodTailor: true,
                editableInMcLeodTailor: true,
                description: "This controls if the component's inner fields are displayed next to each other (horizontally), or if they are stacked (vertically)."
            },
            rangeDefault: {
                type: PropType.bool,
                category: "Range",
                defaultValue: false,
                visibleInMcLeodTailor: true,
                editableInMcLeodTailor: true,
                description: "If the user is offered the 'Range Selection' option, this controls if that option is on/off by default."
            },
            rangeOffered: {
                type: PropType.bool,
                category: "Range",
                defaultValue: false,
                visibleInMcLeodTailor: true,
                editableInMcLeodTailor: { baseComponent: false, customComponent: true },
                description: "This controls if the user is offered the option to define the input as a range."
            }
        }
    }
}
